module.exports = __webpack_public_path__ + "static/media/cw.665d89cd.webp";